import { SVGProps } from 'react';

const WifiLow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 20h.01M8.5 16.429a5 5 0 0 1 7 0"
    />
  </svg>
);
export default WifiLow;
